// const orderList = [];
// console.log(orderList, 'este es el arreglo orderlist');
// const addOrder=()=>{
//   orderList.push({iterm : 'elnombre', price: 'elprecio'})
//   // return orderList;
// }

// export default addOrder;

const handleClick=(e)=> {
  e.preventDefault();
  console.log('The link was clicked.');
}

export default handleClick;